import getId from './getId'

const getTableId = () => {
  return `t_${getId()}`
}

export default getTableId
